import { entityValue } from 'app/infrastructure/store/entity';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { Entity } from 'app/types-shared';
import maxBy from 'lodash/maxby';
import minBy from 'lodash/minby';
import isNumber from 'lodash/isnumber';

export const sequence = (connection: Entity) => {
  return Number(entityValue(connection, columnName[tableName.connectedCases].connectedSequence));
};

export const maxSequenceEntity = (connections: Entity[]) => {
  return maxBy(connections, c => sequence(c));
};

export const minSequenceEntity = (connections: Entity[]) => {
  return minBy(connections, c => sequence(c));
};

export const nextSequenceValue = (maxSequence: number) => {
  return (maxSequence && isNumber(maxSequence)) ? maxSequence + 1 : 1;
};
